import { createSlice } from "@reduxjs/toolkit";

const tokenSlice = createSlice({
  name: "token",
  initialState: {},
  reducers: {
    loginBuyer(state, action) {
      state.token = action.payload.token;
      state.email = action.payload.email;
      state.buyerId = action.payload.buyerId;
    },
    logoutBuyer(state, action) {
      state.token = null;
      state.email = null;
      state.buyerId = null;
    },
  },
});

export const { loginBuyer, logoutBuyer } = tokenSlice.actions;

export default tokenSlice.reducer;
